module.exports = __webpack_public_path__ + "static/img/01hi.7787e6e9.gif";